<div class="vendor-document-container">
    <div>
        <p class="heading-h6-medium">Vendor documents</p>
    </div>
    <div class="download-button-container">
        <app-button type="flat-button" class="padBtn mar-r" name="Download all"
            (click)="!isDownloadAllDisabled && downloadAllData()" [disabled]="isDownloadAllDisabled"></app-button>
    </div>
    <div class="vendor-document" *ngFor="let vendor of vendorList">
        <p class="vendor-heading">{{ vendor.Name }}</p>
        <app-quotation-list [attachments]="vendor.QuotationAttachment" [user]="user" [vendor]="vendor"
            [statusData]="statusData" [userList]="userList" [rfqAttachments]="rfqAttachments"
            [isReadOnlyRFQSummary]="isReadOnlyRFQSummary"
            (quotationUploadChanged)="checkAttachments()"></app-quotation-list>
    </div>
</div>